import type { RodapeDoPreco, TermosAssinatura } from '../utils/termos-assinatura';

/**
 * Valor cobrado da barra fixa do celular com a frequência logo abaixo
 * ("R$ 718,80/ano" · "em 12x de R$ 59,90 no cartão · renova automaticamente").
 * Sem isso a barra mostrava só "R$ 59,90 + FRETE GRÁTIS" — um dos motivos da
 * recusa da Google Play em 28/10/2026.
 *
 * Quem usa põe isto numa coluna `min-w-0 flex-1`: o valor não quebra, mas o
 * sufixo e o detalhe quebram — o botão ao lado nunca é empurrado pra fora.
 */
export function PrecoDoRodape({ rodape }: { rodape: RodapeDoPreco }) {
  return (
    <>
      <h3 className="font-bold text-2xl leading-tight">
        <span className="whitespace-nowrap">{rodape.valor}</span>
        {rodape.sufixo && <span className="text-base font-semibold">{rodape.sufixo}</span>}
      </h3>
      <p className="text-xs font-semibold text-[#2C2F3A] leading-snug">{rodape.detalhe}</p>
    </>
  );
}

/** Termos completos da assinatura, logo acima do botão de pagar. */
export function QuadroDeTermos({ termos }: { termos: TermosAssinatura }) {
  return (
    <section
      aria-label="Termos da assinatura"
      className="mt-5 rounded-lg border border-[#DBECFF] bg-[#F5FAFF] p-4 text-sm text-[#3F4D54]"
    >
      <h3 className="font-semibold text-[#0168AC] mb-2">Termos da assinatura</h3>
      <ul className="flex flex-col gap-1.5 list-disc pl-4">
        {termos.linhas.map((linha) => (
          <li key={linha}>{linha}</li>
        ))}
      </ul>
    </section>
  );
}
